import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider, useApp } from './context/AppContext';
import NavBar from './components/NavBar';
import LogEntry from './pages/LogEntry';
import MyLogs from './pages/MyLogs';
import Admin from './pages/Admin';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Landing from './pages/Landing';
import './index.css';

function ProtectedRoute({ children, adminOnly }) {
  const { user, isAdmin, authLoading } = useApp();
  if (authLoading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '80vh', color: 'var(--text-muted)' }}>
      Loading...
    </div>
  );
  if (!user) return <Navigate to="/login" />;
  if (adminOnly && !isAdmin) return <Navigate to="/log" />;
  return children;
}

function AppRoutes() {
  const { user, isAdmin, authLoading } = useApp();

  if (authLoading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', color: 'var(--text-muted)' }}>
      Loading...
    </div>
  );

  return (
    <>
      {user && <NavBar />}
      <Routes>
        <Route path="/" element={
          !user ? <Landing /> :
          isAdmin ? <Navigate to="/admin" /> :
          <Navigate to="/log" />
        } />
        <Route path="/login" element={
          !user ? <Login /> :
          isAdmin ? <Navigate to="/admin" /> :
          <Navigate to="/log" />
        } />
        <Route path="/signup" element={user ? (isAdmin ? <Navigate to="/admin" /> : <Navigate to="/log" />) : <Signup />} />
        <Route path="/log" element={<ProtectedRoute><LogEntry /></ProtectedRoute>} />
        <Route path="/logs" element={<ProtectedRoute><MyLogs /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AppProvider>
  );
}
